import { styled } from '@mui/system';
import { AccordionDetails } from '@mui/material';

export const RootSection = styled('section')(({ theme }) => ({
  margin: theme.spacing(0, 3, 2, 3),
  [theme.breakpoints.down('md')]: {
    margin: theme.spacing(0, 0, 1, 0),
    padding: theme.spacing(1)
  }
}));

export const StyledAccordionDetails = styled(AccordionDetails)(() => ({
  display: 'flex',
  flexWrap: 'wrap'
}));

export const addressbookLabelStyles = theme => ({
  minWidth: 200,
  width: 200,
  margin: theme.spacing(1),
  border: `1px solid ${theme.palette.grey[400]}`,
  textAlign: 'start'
});
